import * as React from 'react';
// @ts-expect-error
import type {StylesConfig} from 'react-select';

import type {SelectComponentValue} from 'nutshell-core/types';

import {Label} from 'shells/form/label';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import type {
    EntityAttributeEnum as EntityAttributeEnumFragment,
    CustomFieldValueInput,
} from 'nutshell-graphql-types';

import styles from './graphql-field-enum.module.css';

type Props = {
    field: EntityAttributeEnumFragment;
    value: CustomFieldValueInput['enumSingle'];
    onChange: (newVal: CustomFieldValueInput) => any;
    label: string;
    blinkSuccess: boolean;
    styles?: StylesConfig;
    menuPortalTarget?: HTMLElement;
};

export class GraphQLFieldEnumSingle extends React.PureComponent<Props> {
    render() {
        const options = this.props.field.options.map((opt) => ({
            id: opt.id,
            name: opt.name,
        }));

        return (
            <div className={styles['graphql-field-enum']}>
                <Label htmlFor={this.props.field.attribute.name}>{this.props.label}</Label>
                <SelectPickerGeneric
                    valueKey='id'
                    labelKey='name'
                    placeholder='Choose option…'
                    blinkSuccess={this.props.blinkSuccess}
                    name={this.props.field.attribute.name}
                    value={options.filter(({id}) => id === this.props.value)}
                    options={options}
                    styles={this.props.styles}
                    menuPortalTarget={this.props.menuPortalTarget}
                    onClear={this.handleClear}
                    onChange={this.handleChange}
                />
            </div>
        );
    }

    handleChange = (newVal: SelectComponentValue) => {
        this.props.onChange({
            enumSingle: newVal.id,
        });
    };

    handleClear = () => {
        this.props.onChange({
            enumSingle: null,
        });
    };
}
